/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react'

interface AccountLogicProps {
  Wrapper: FC<any>
  className?: string
}

const AccountLogic: FC<AccountLogicProps> = ({ Wrapper, className }) => {
  return <Wrapper className={className} />
}

export default AccountLogic
